import React, { useEffect, useState } from 'react'
import StarIcon from '@mui/icons-material/Star';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import StairsIcon from '@mui/icons-material/Stairs';
import Status from '../../Components/Status/Status';
import { Oval } from 'react-loader-spinner';
// import ProgressBar from "@ramonak/react-progress-bar";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import axios from 'axios';
import { useQuery } from 'react-query';
import { baseUrl, path } from '../../constants';
import { Link } from 'react-router-dom';
import Preview from '../Preview/Preview';
import { api } from '../../api';
import { toast } from 'react-toastify';
import Select from 'react-select'

export default function Withdrawals() {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [selectedRequest, setSelectedRequest] = useState(null)
    const [tab, setTab] = useState(1)

    const fetchWithdrawals = () => {
        setLoading(true)
        api.get(path.withdrawal + '?type=' + tab).then(response => {
            let data = response.data
            if(data.success){
                setData(data.withdrawals)
            }
        }).finally(() => setLoading(false))
    }

    useEffect(fetchWithdrawals, [tab])
    
  return ( 
  <div className='flex flex-col flex-1 overflow-auto gap-4'>
      <div className='flex items-center gap-4'>
          <button onClick={() => setTab(1)} className={`px-4 py-2 font-bold rounded-md ${tab == 1 ? 'text-white bg-main' : 'text-main bg-white border-[1px] border-main'}`}>
              Pending Withdrawals
          </button>
          <button onClick={() => setTab(2)} className={`px-4 py-2 font-bold rounded-md ${tab == 2 ? 'text-white bg-main' : 'text-main bg-white border-[1px] border-main'}`}>
              Processing Withdrawals
          </button>
          <button onClick={() => setTab(3)} className={`px-4 py-2 font-bold rounded-md ${tab == 3 ? 'text-white bg-main' : 'text-main bg-white border-[1px] border-main'}`}>
              Completed Withdrawals
          </button>
      </div>
    {loading ? (
        <div className='flex flex-col items-center gap-3'>
            <p className='text-black text-[15px]'>Loading data...</p>
            <Oval
                visible={true}
                height="30"
                width="30"
                color="#52a4e0"
                secondaryColor="#ffffff"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
                strokeWidth={3}
                />
        </div>
    ) :(
        <table className='courses rounded-md overflow-hidden'>
            <thead className='bg-black'>
                <tr className='text-white text-left'>
                    <th className='p-2'>Seller</th>
                    <th className='p-2'>Amount</th>
                    <th className='p-2'>Bank Name</th>
                    <th className='p-2'>Account Name</th>
                    <th className='p-2'>Account Number</th>
                    <th className='p-2'>Status</th>
                    <th className='p-2'>Requested Date</th>
                    {tab == 3 && (
                        <>
                             <th className='p-2'>Deposited Date</th>
                            <th className='p-2'>Responsible Person</th>
                        </>
                    )}
                    <th className='p-2 text-center'>Actions</th>
                </tr>
            </thead>
            <tbody>
                {data?.map(request => ( 
                    <tr>
                        <td className='p-2'>{`${request.user?.firstName} ${request.user?.lastName}`}</td>
                        <td className='p-2'>{request?.withdraw_amount}</td>
                        <td className='p-2'>{request?.bank_name}</td>
                        <td className='p-2'>{request?.account_name}</td>
                        <td className='p-2'>{request?.account_number}</td>
                        <td className='p-2'><span className='text-[#00ff00] text-sm font-bold bg-black px-2 py-1 rounded-sm'>{['PENDING', 'PROCESSING', 'COMPLETE'][request?.status - 1]}</span></td>
                        <td className='p-2'>{request?.createdAt?.split('T')?.at(0)}</td>
                        {tab == 3 && (
                            <>
                                <td className='p-2'>{request.deposited_date?.split('T')?.at(0)}</td>
                                <td className='p-2'>{request.responsible_person}</td>
                            </>
                        )}
                        <td className='p-2 flex gap-2 items-center justify-center'>
                            <button className='text-white px-4 py-2 bg-main text-xs font-bold rounded-md' onClick={() => setSelectedRequest(request)}>Change Status</button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )}

    {selectedRequest && <ChangeStatus request={selectedRequest} setRequest={setSelectedRequest} refetch={fetchWithdrawals} />}
    </div>
  )
}


function ChangeStatus({ request, refetch, setRequest }){
    const [submitting, setSubmitting] = useState(false)
    const [status, setStatus] = useState(request.status)
    const [responsible, setResponsible] = useState(null)

    const submit = () => {
        setSubmitting(true)
        api(path.withdrawal, {
            method: 'patch',
            data: {
                id: request.id,
                responsible_person: responsible,
                type: status
            }
        }).then(response => {
            if(response.data.success){
                toast.success('Success! Status changed.', {
                    hideProgressBar: true
                })
                setRequest(null)
                refetch()
            } else {
                toast.error('Sorry. something went wrong!', {
                    hideProgressBar: true
                })
            }
        }).finally(() => setSubmitting(false))
    }

    const options = [
        {label: 'Pending', value: 1},
        {label: 'Processing', value: 2},
        {label: 'Completed', value: 3}
    ]
    return (
        <div className='fixed bg-[#00000060] z-[999999] inset-0 flex items-center justify-center'>
            <div className='bg-white flex flex-col items-center gap-6 p-4 rounded-md'>
                <h1>Withdrawal Request: <span className='font-bold'>{request.withdraw_amount} ETB</span></h1>
                <p>Status:</p>
                <Select
                    className='w-[300px] text-black rounded-md'
                    options={options}
                    onChange={e => setStatus(e.value)}
                    defaultValue={options.find(o => o.value == status)}
                />
                {status == 3 && <input placeholder='Responsible Person'  className='w-[300px] text-black border-[1px] border-black p-2 rounded-md' value={responsible} onChange={(e) => setResponsible(e.target.value)} />}
                <div className='flex self-stretch gap-2'>
                    <button disabled={submitting} onClick={submit} type='submit' className={`${(submitting) ? 'bg-[#a3a3a3]' : 'bg-main'} text-white text-[14px] flex-1 p-2 flex items-center justify-center`}>
                    {submitting ? (
                            <Oval
                                visible={true}
                                height="21"
                                width="21"
                                color="#ffffff"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                strokeWidth={3}
                            />
                        ) : 'Change'}
                    </button>
                    <button onClick={() => setRequest(false)} className='border-[1px] border-[#00000070] p-2 text-[14px] flex-1'>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    )
}

// export function CourseCard(course) {
//   return (
//     <div href='/' to={'/course/232323'} className='bg-white flex flex-col p-2 rounded-md gap-2 shadow-lg flex-1 h-[400px] hover:scale-105 transition-all cursor-pointer'>
//         <img className='rounded-md h-1/2 w-full object-cover' src={baseUrl + course.thumbnail} alt='course'/>
//         <p className='text-black text-sm font-bold'>{course.title}</p>
//         <p className='text-[#6a6f73] text-xs'>by {course?.instructor?.user?.firstName + ' ' + course.instructor.user.lastName}</p>
//         <div className='flex items-center gap-1'>
//             <p className='text-black text-xs'>{course.value}</p>
//             <StarIcon style={{color: 'black', fontSize: 12}}>Filled</StarIcon>
//             <p className='text-black text-xs'>Rating: {0}</p>
//         </div>
//         <hr />  
//         <div className='flex justify-between p-2 items-center'>
//             <div className='flex items-center gap-2'>
//                 <PeopleAltIcon style={{color: '#000000', fontSize: 12}}>Filled</PeopleAltIcon>
//                 <p className='text-black text-xs'>{course.enrollmentCount} Enrolled</p>
//             </div>

//             <div className='flex items-center gap-2'>
//                 <StairsIcon style={{color: '#000000', fontSize: 12}}>Filled</StairsIcon>
//                 <p className='text-black text-xs'>{course.level}</p>
//             </div>
//         </div>
//         <div className='flex w-full gap-[7px] p-[7px]'>
//             <Link to={`/course-sections/${course.id}`} className='p-1 flex-1 self-center rounded-sm bg-[#198754] text-[#ffffff] no-underline text-md text-center'>Manage Sections</Link>
//             <button onClick={() => course.setSelectedCourse(course.id)} className='p-1 flex-1 self-center rounded-sm bg-[#198754] text-[#ffffff] no-underline text-md text-center'>Preview</button>
//         </div>
//     </div>
//   )
// }
